// Tiptap's default NodeView boundary recognizes a BUTTON itself, but not its
// nested caption or SVG path. Such a mousedown selects the atom on mouseup and
// can leave editor state behind the native caret after the next text tap.
// Let controls own their events without preventing native focus/playback.
export function stopNodeViewControlEvent({ event }) {
  if (event.type === 'drop' || event.type.startsWith('drag')) return false;
  return Boolean(event.target?.closest?.('button, a[href], input, textarea, select, iframe, audio, video, [role="button"]'));
}
